// Widget de reserva de GoHighLevel (demo). Abrir vía evento global para no pasar props en toda la app.
export const BOOKING_URL = "https://api.leadconnectorhq.com/widget/bookings/narwhal";
export const BOOKING_EVENT = "narwhal:book";
export const openBooking = () => window.dispatchEvent(new Event(BOOKING_EVENT));
